import { Theme } from '@mui/material';
import { CSSObject } from '@mui/material/styles';

export const LICENCE_CHANGE_DIALOG_CLASS = 'licence-change-dialog';
export const LICENCE_CHANGE_LOADING_CLASS = 'licence-change-dialog__loading';
export const LICENCE_CHANGE_BODY_CLASS = 'licence-change-dialog__body';
export const LICENCE_CHANGE_ERROR_CLASS = 'licence-change-dialog__error';
export const LICENCE_CHANGE_ALLOWANCE_MODE_CLASS = 'licence-change-dialog__allowance-mode';
export const LICENCE_CHANGE_ALLOWANCES_CLASS = 'licence-change-dialog__allowances';
export const LICENCE_CHANGE_BEFORE_CLASS = 'licence-change-dialog__before';
export const LICENCE_CHANGE_ARROW_CLASS = 'licence-change-dialog__arrow';
export const LICENCE_CHANGE_AFTER_CLASS = 'licence-change-dialog__after';
export const LICENCE_CHANGE_CHANGED_CLASS = 'licence-change-dialog__after--changed';
export const LICENCE_CHANGE_ADDITIONS_CLASS = 'licence-change-dialog__additions';
export const LICENCE_CHANGE_RESTRICTION_TEXT_CLASS = 'licence-change-dialog__restriction-text';
export const LICENCE_CHANGE_NOTE_CLASS = 'licence-change-dialog__note';
export const LICENCE_PENDING_NOTE_CLASS = 'licence-pending-note';

/**
 * The admin's licence-change confirmation (PTEC-977), and the note on the organisation's
 * account card while a change waits for payment.
 *
 * Registered against `MuiPaper` in both palettes, like the upgrade banner: the dialog's
 * surface is a Paper (the class is passed through `PaperProps`) and so is the account
 * card, so the components only decide what they say, not what it looks like.
 */
export const licenceChangeStyles = (theme: Theme): CSSObject => ({
	[`&.${LICENCE_CHANGE_DIALOG_CLASS}`]: {
		[`& .${LICENCE_CHANGE_LOADING_CLASS}`]: {
			display: 'flex',
			justifyContent: 'center',
			padding: theme.spacing(4, 0)
		},

		[`& .${LICENCE_CHANGE_ERROR_CLASS}:not(:last-child)`]: {
			marginBottom: theme.spacing(2)
		},

		[`& .${LICENCE_CHANGE_BODY_CLASS}`]: {
			display: 'flex',
			flexDirection: 'column',
			gap: theme.spacing(2)
		},

		// The question, then "set exactly" and "keep extras".
		[`& .${LICENCE_CHANGE_ALLOWANCE_MODE_CLASS}`]: {
			display: 'flex',
			flexDirection: 'column',
			gap: theme.spacing(1)
		},

		// Allowance, before, arrow, after: one row per allowance the change touches.
		[`& .${LICENCE_CHANGE_ALLOWANCES_CLASS}`]: {
			alignItems: 'center',
			columnGap: theme.spacing(2),
			display: 'grid',
			gridTemplateColumns: '1fr auto auto auto',
			rowGap: theme.spacing(0.5)
		},

		[`& .${LICENCE_CHANGE_BEFORE_CLASS}, & .${LICENCE_CHANGE_ARROW_CLASS}`]: {
			color: theme.palette.text.secondary
		},

		[`& .${LICENCE_CHANGE_BEFORE_CLASS}, & .${LICENCE_CHANGE_AFTER_CLASS}`]: {
			textAlign: 'right'
		},

		[`& .${LICENCE_CHANGE_CHANGED_CLASS}`]: {
			fontWeight: 600
		},

		[`& .${LICENCE_CHANGE_ADDITIONS_CLASS}`]: {
			alignItems: 'center',
			display: 'flex',
			flexWrap: 'wrap',
			gap: theme.spacing(1)
		},

		[`& .${LICENCE_CHANGE_RESTRICTION_TEXT_CLASS}`]: {
			marginBottom: theme.spacing(1)
		},

		[`& .${LICENCE_CHANGE_NOTE_CLASS}`]: {
			color: theme.palette.text.secondary
		}
	},

	[`& .${LICENCE_PENDING_NOTE_CLASS}`]: {
		color: theme.palette.warning.main
	}
});
